// Vendors
import { useEffect } from 'react';
// Handlers
import { SignedHandlers } from '../handlers/signed.handlers';

const useSignedHook = (): void => {
  const { handleRedirectAfterSigned } = SignedHandlers();

  useEffect(() => {
    handleRedirectAfterSigned();
  }, []);
};

export { useSignedHook };
